import * as React from 'react';
import { connect } from 'react-redux';
import Form, { FormComponentProps } from 'antd/lib/form';
import Modal from 'antd/lib/modal';
import Checkbox from 'antd/lib/checkbox';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Tooltip from 'antd/lib/tooltip';
import Icon from 'antd/lib/icon';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import { isValidArray } from 'src/Library/Helper';
import {getDeadlineData} from '../InquiryUtils';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  checkboxes: {
    '& .ant-checkbox-group-item': {
      marginBottom: '9px',
      fontSize: `${tokens.fontSize.body}px`,
      color: '#262626',
    },
    '& .ant-checkbox + span': {
      paddingRight: '12px',
    },
  },
  rejectInquiryModal: {
    '& .ant-modal-title': {
      fontSize: `${tokens.fontSize.h3}px`,
      color: '#444444',
      fontWeight: 'bold',
    },
    '& .ant-modal-body': {
      padding: 0,
    },
  },
  modalBodyText: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: 'black',
  },
  inquiryHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 23px',
    backgroundColor: '#F9F9F9',
  },
});

interface IProps extends
  StylesProps<ReturnType<typeof styles>>, FormComponentProps {
  visible: boolean;
  handleRejectInquiry: (rejectedReasonList, remarks) => void;
  handleCancel: () => void;
  inquiryRejectionReasons: string[];
  deadlineDate: number;
  inquiryReferenceNumber: string;
  loading: boolean;
}

const FFInquiryRejectModal = (props: IProps) => {
  const {
    visible,
    handleRejectInquiry,
    handleCancel,
    inquiryRejectionReasons,
    classes,
    deadlineDate,
    inquiryReferenceNumber,
    loading,
    form: { getFieldDecorator, getFieldValue },
  } = props;

  const isDisabled = !isValidArray(getFieldValue('rejectedReasonList'));

  const renderDeadline = () => {
    const deadlineData = getDeadlineData(deadlineDate);
    const {deadline,deadlineString, deadlineColor, isDeadlineNear} = deadlineData;
    if (!deadline) return;

    return <div style={{ fontSize: '11px', color: `${deadlineColor}` }}>
      <Tooltip title={isDeadlineNear ? deadline : ''}>
        <Icon type="hourglass" style={{ marginRight: '11px', fontSize: `${tokens.fontSize.body}px` }} />
        <span>{deadlineString}</span>
      </Tooltip>
    </div>;
  }

  const handleReject = () => {
    const rejectedReasonList = getFieldValue('rejectedReasonList');
    const remarks = getFieldValue('remarks');
    handleRejectInquiry(rejectedReasonList, remarks);
  };

  const renderInquiryHeader = () => {
    return (
      <div className={classes.inquiryHeader}>
        <span style={{ fontSize: `${tokens.fontSize.h3}px`, color: '#1875F0', fontWeight: 'bold' }}>
          {inquiryReferenceNumber}
        </span>
        {renderDeadline()}
      </div>
    );
  };

  const RenderCheckboxes = () => {
    return (
      <div style={{ padding: '30px 24px', marginBottom: '10px' }}>
        <p className={classes.modalBodyText}>Select your reason for declining this Inquiry</p>
        <Form.Item>
          {getFieldDecorator('rejectedReasonList', { initialValue: [] })(
            <Checkbox.Group className={classes.checkboxes} options={inquiryRejectionReasons} />
          )}
        </Form.Item>
        <p style={{ fontSize: `${tokens.fontSize.caption}px`, marginTop: '12px', marginBottom: 0 }}>
          <span className={classes.modalBodyText}>Remarks</span> (Optional)
        </p>
        <Form.Item>
          {getFieldDecorator('remarks', { initialValue: '' })(
            <Input.TextArea
              style={{ marginTop: '8px', height: '70px', fontSize: `${tokens.fontSize.small}px` }}
              placeholder="Write your concerns for the selected option here !"
            />
          )}
        </Form.Item>
      </div>
    );
  };

  const renderRejection = () => {
    return (
      <div
        style={{
          fontSize: tokens.fontSize.body,
          letterSpacing: '0.17px',
          lineHeight: '22px',
        }}
      >
        {renderInquiryHeader()}
        {RenderCheckboxes()}
      </div>
    );
  };

  return (
    <Modal
      className={classes.rejectInquiryModal}
      width={450}
      title="Decline Inquiry"
      visible={visible}
      style={{ padding: '0' }}
      onCancel={handleCancel}
      footer={[
        <a onClick={handleCancel} style={{ color: '#424242', marginRight: '16px' }}>
          Cancel
        </a>,
        <Button
          key="submit"
          type="primary"
          onClick={() => handleReject()}
          loading={loading}
          style={{
            background: isDisabled ? '#999999' : tokens.colors.primary,
            border: tokens.colors.primary,
            color: tokens.colors.bgWhite,
          }}
          disabled={isDisabled}
        >
          Decline
        </Button>,
      ]}
    >
      {renderRejection()}
    </Modal>
  );
};

const mapStateToProps = ({ inquiryReducer }, ownProps) => ({
  inquiryRejectionReasons: inquiryReducer.masterData.inquiryRejectionReasons,
});

export default (Form.create<any>())(connect(mapStateToProps)(withStyles(styles)(React.memo(FFInquiryRejectModal))));
